<template>
    <div class="content-wrap">
        <resultFilter @searchForm="getSearchForm"></resultFilter>
        <div class="card-wrap">
            <div class="card-item">
                <div class="common-title">项目清单</div>
                <div class="search-wrap">
                    <van-field v-model="sKeywords" right-icon="search" placeholder="输入搜索签单手" @click-right-icon="search" />
                </div>
                <div class="table-wrap">
                    <el-table :data="arrRankList" style="width: 100%" :header-row-style="{ color: '#318544', border: 'none' }" :cell-style="cellStyle">
                        <el-table-column type="index" label="排名" align="center" width="50">
                            <template slot-scope="scope">
                                <div>{{handlerSelesRanking(scope.$index)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="name" label="签单手" width="60">
                        </el-table-column>
                        <el-table-column align="center" prop="title" label="所属公司">
                        </el-table-column>
                        <el-table-column align="center" prop="value" label="业绩" width="60">
                            <template slot-scope="scope">
                                <div>{{scope.row.value}}万</div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="value" label="单数" width="60">
                            <template slot-scope="scope">
                                <div>{{scope.row.value1}}单</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page-wrap">
                    <el-performance :page="nRankPage" :nNumber="nTotal" @next="next" @last="last" @active="getActive" :bBackfoued="false"></el-performance>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import resultFilter from '@/components/hvac/performance/project/resultfilter.vue'
import elPerformance from "@/components/common/pagination/index.vue";
import oAnalysisJs from "@/js/hvac/performance/result.js"

export default {
    name: "list",
    components: {
        resultFilter,
        elPerformance
    },
    data() {
        return {
            currentPage: 1,
            //搜索表单
            oSearchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: ""
            },
            //业绩榜单 worker 签单手 office 办事处 province 省区 channel 渠道
            sRankType: "worker",
            //项目 money-金额 project-项目
            sRankItem: "money",
            nRankPage: 1,
            arrRankList: [],
            nTotal: 0,
            sKeywords: "",
            
        }
    },
    methods: {
        cellStyle(row) {
            if (row.columnIndex === 1) {
                return 'color: #444444; fontWeight: 500'
            }
            if (row.columnIndex === 3) {
                return 'color: #318544; fontWeight: 500'
            }
            if (row.columnIndex === 4) {
                return 'color: #318544; fontWeight: 500'
            }
        },
        // 点击页数
        getActive(page) {
            let _that = this;
            _that.nRankPage = page;
            _that.getPerformanceRank();
        },
        // 上一页
        last(page) {
            let _that = this;
            _that.nRankPage = page;
            _that.getPerformanceRank();
        },
        // 下一页
        next(page) {
            let _that = this;
            _that.nRankPage = page;
            _that.getPerformanceRank();
        },
        getSearchForm(val) {
            this.oSearchForm = val;
            this.getPerformanceRank()
        },
        //业绩榜单
        getPerformanceRank() {
            this.$store.commit("loadSwitch", true);
            let data = {
                type: this.sRankType,
                item: this.sRankItem,
                page: this.nRankPage,
                keywords: this.sKeywords,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end
            }
            oAnalysisJs.getPerformanceRank(data).then(res => {
                let result = res.data.data.result
                // if (this.nRankPage == 1) {
                //     this.arrRankList = result.list;
                // } else {
                //     if (result.list.length) {
                //         this.arrRankList = this.arrRankList.concat(result.list);
                //     } else {
                //         this.$toast("暂无数据")
                //     }
                // }
                this.arrRankList = result.list;
                this.nTotal = Number(result.total_page)
                this.$store.commit("loadSwitch", false);
            })
        },
        //处理下排名的问题
        handlerSelesRanking(index) {
            let page = this.nRankPage - 1;
            return page == 0
                ? index + 1
                : index + 1 + page * 10;
        },
        search() {
            //if (this.sKeywords) {
                this.nRankPage = 1
                this.getPerformanceRank()
            //} else {
                //this.$toast("请输入签单手")
            //}
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../result/index";

.content-wrap {
    background: #f0f4f1;

    .card-wrap {
        width: 93.6%;
        margin: 20px auto 24px;
        background: #fff;
        padding: 28px 24px 32px;
        border-radius: 12px;

        .card-item {
            margin-bottom: 30px;
            border-bottom: 2px dashed #f1f1f1;

            &:last-child {
                border: none;
                margin-bottom: 0;
            }
        }

        .search-wrap {
            margin-top: 22px;
        }

        .contract-project-wrap {
            padding: 24px 0 40px;

            .contract-project {
                width: 100%;
                height: 160px;
                background: #f7f7f7;
                border-radius: 16px;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .contract-title {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #858585;
                    line-height: 40px;
                }

                .contract-count {
                    font-size: 68px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #318544;
                    line-height: 96px;
                }
            }
        }

        .table-wrap {
            width: 100%;
            margin-top: 20px;
            color: #858585;
        }
    }

    .common-title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 40px;
    }
}

::v-deep .van-field {
    background: #f7f7f7;
    border-radius: 12px;
}

.page-wrap {
    margin: 0 auto;
    margin-top: 24px;
    overflow: hidden;
}
</style>